import React, { createContext, useContext, useMemo, useState } from 'react'

const TableRowsContext = createContext(null)

const useTableRows = () => {
  const context = useContext(TableRowsContext)
  if (!context) {
    throw new Error('useCount must be used within a TableRowsProvider')
  }
  return context
}

const TableRowsProvider = props => {
  const [tableRows, setTableRows] = useState(15)

  const value = useMemo(() => ({ tableRows, setTableRows }), [tableRows])
  return <TableRowsContext.Provider value={value} {...props} />
}

export { TableRowsProvider, useTableRows }
